const BASE_URL = 'user';

export const PATHS = {
  BASE_URL,
  PROFILE: `${BASE_URL}/profile`,
};
